module.exports = __webpack_public_path__ + "img/on-boarding.a3fa7f30.svg";